const entities = {
  blocktrain: 'blocktrain',
  railcar: 'railcar',
  trainCompany: 'train-company',
}

export default entities
